export default "__VITE_ASSET__Cn6xVACu__"